module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (213).94e52f3b.jpg";